<template>
  <header class="page-header">
    <div class="page-header__content">
      <div class="page-header__title-row">
        <h1 :id="titleId" class="page-header__title" tabindex="-1">{{ title }}</h1>
        <div v-if="$slots.status" class="page-header__status">
          <slot name="status" />
        </div>
      </div>
      <p v-if="description" class="page-header__description">{{ description }}</p>
      <div v-if="$slots.metadata" class="page-header__metadata">
        <slot name="metadata" />
      </div>
    </div>
    <page-actions v-if="$slots.actions" class="page-header__actions" :aria-label="actionsLabel">
      <slot name="actions" />
    </page-actions>
  </header>
</template>

<script>
import PageActions from './PageActions.vue'

export default {
  name: 'PageHeader',
  components: { PageActions },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    titleId: {
      type: String,
      default: 'page-title'
    },
    actionsLabel: {
      type: String,
      default: 'Действия страницы'
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sid-space-5);
  margin-bottom: var(--sid-space-6);
}

.page-header__content {
  min-width: 0;
  max-width: 56rem;
}

.page-header__title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sid-space-3);
}

.page-header__title {
  margin: 0;
}

.page-header__description,
.page-header__metadata {
  margin: var(--sid-space-2) 0 0;
  color: var(--sid-color-text-secondary);
}

.page-header__metadata {
  font-size: var(--sid-font-size-label);
  line-height: var(--sid-line-height-label);
}

.page-header__actions {
  flex: 0 1 auto;
}

@media (max-width: 767px) {
  .page-header {
    flex-direction: column;
    gap: var(--sid-space-4);
  }

  .page-header__actions {
    width: 100%;
  }
}
</style>
